module.exports = __webpack_public_path__ + "img/pen-tool.e6eb6671.svg";